import fitpro from "../../../assets/images/fitpro.png";
import React, { useState } from "react";
import { SidebarNavigation } from "./SidebarNav";
import { useLocation, Link } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";

const Sidebar = () => {
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  return (
    <aside className="w-full p-3">
      <div className="custom-sidebar__logo">
      <img
          src={fitpro}
          alt="Fitpro Logo"
          className="custom-sidebar__logo-img"
        />
      </div>

      <ul className="custom-sidebar__menu">
        {SidebarNavigation.map((item, index) => {
          const isActive = location.pathname === item.link;
          const isDropdownOpen = openDropdown === index;

          return (
            <li key={index} className="custom-sidebar__menu-item">
              <div
                className={`custom-sidebar__link ${isActive ? "custom-sidebar__link--active" : ""}`}
                onClick={() => item.subItems && toggleDropdown(index)}
              >
                <Link to={item.link || "#"} className="custom-sidebar__link-content">
                  <span className="custom-sidebar__icon">{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
                {item.subItems && (
                  <FaChevronDown
                    className={`custom-sidebar__chevron ${isDropdownOpen ? "rotate" : ""}`}
                  />
                )}
              </div>

              {item.subItems && (
                <ul
                  className={`custom-sidebar__dropdown ${isDropdownOpen ? "custom-sidebar__dropdown--show" : ""}`}
                >
                  {item.subItems.map((subItem, subIndex) => (
                    <li key={subIndex} className="custom-sidebar__dropdown-item">
                      <Link to={subItem.target || "#"}>{subItem.label}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default Sidebar;

  